<template>
    <div class="profile-root">
        <Header :label="fullName" overlap="small" />
        <UserNavSection />

        <MainLayout margin-top>
            <FavoriteModule slot="center" />
            <PostingModule
                slot="center"
                noToggles
                :label="$t('mypage.suggestedPositions')"
                :data="data()"
                :queryInfo="queryInfo()"
                :isLoading="loading()"
            />

            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
            <VerifyModule slot="right" />
        </MainLayout>
    </div>
</template>

<script>
// Project components
import Header from '../../components/layouts/Header';
import MainLayout from '../../components/layouts/mainlayout/MainLayout';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import VerifyModule from '~/components/miscellaneous/VerifyModule';
import FeaturedResource from '~/components/smart/FeaturedResource';

// Page components
import UserNavSection from '~/shared/UserNavSection';
import PostingModule from '~/shared/postingmodule/PostingModule';
import CompanyList from '~/shared/CompanyList';
import FavoriteModule from './components/FavoriteModule';

// Utils
import AuthService from '~/services/AuthService';
import userDataToName from '~/utils/user/userDataToName';

export default {
    name: 'MyPage',
    components: {
        Header,
        MainLayout,
        UserNavSection,
        PostingModule,
        CompanyList,
        ProfileModule,
        VerifyModule,
        FavoriteModule,
        FeaturedResource,
    },
    data: () => ({
        forceUpdate: false,
        followedCompanies: [],
        isLoadingFollowedCompanies: false,
    }),
    computed: {
        fullName() {
            return userDataToName(this.user.data, 'mypage.header');
        },
        postings() {
            return this.$interfaces.posting.get({ reactive: true });
        },
        isAuthenticated() {
            return this.$interfaces.logInModule.isLoggedIn();
        },
        user() {
            return this.$interfaces.user.me.get({ reactive: true });
        },
    },
    methods: {
        data() {
            return (this.postings.data || []).slice(0, 4);
        },
        queryInfo() {
            return this.postings.queryInfo;
        },
        loading() {
            return this.postings.loading;
        },
        error() {
            return this.postings.error;
        },
    },
};
</script>

<style scoped>
.profile-root {
    padding-bottom: 100px;
}
</style>
